import { API_HOUSEHOLD } from "../constants";

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case API_HOUSEHOLD.SET:
      return action.data;
    case "@APP/RESET":
      return initialState;
    default:
      return state;
  }
}
